var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.101,
    height: 61.9,
    viewBox: "0 0 66.101 61.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-icon-silhouette",
    transform: "translate(-0.001 -17.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0.001 17.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M64.992,45.02,54.974,34.945V23.307a3.789,3.789,0,1,0-7.577,0v4.018l-7.459-7.5a9.927,9.927,0,0,0-13.779.007L1.109,45.02a3.827,3.827,0,0,0,0,5.389,3.773,3.773,0,0,0,5.36,0l25.046-25.19a2.228,2.228,0,0,1,3.066,0l25.05,25.193a3.778,3.778,0,0,0,5.36,0A3.826,3.826,0,0,0,64.992,45.02Z",
    transform: "translate(-0.001 -17.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M93.836,128.3a1.852,1.852,0,0,0-2.632,0L69.172,150.447a1.881,1.881,0,0,0-.545,1.325v16.156a6.846,6.846,0,0,0,6.826,6.865H86.362V157.8H98.677v16.989h10.909a6.846,6.846,0,0,0,6.826-6.865V151.772a1.874,1.874,0,0,0-.545-1.325Z",
    transform: "translate(-59.47 -112.893)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.d88b52d3e3db27563e276e23267242cb.svg";
export { ForwardRef as ReactComponent };